import Client from './Client'
import { Error } from './Error'

export default class Media extends Client {

  async fetchMedia(id) {
    try {
      return await this.request('get', `media/${id}`, null, null)
    } catch (error) {
      throw new Error(error)
    }
  }
}
